import { championshipFinal, championshipStar, championshipTrophy } from '@/images'

export const STAGE_TYPE = {
  4: {
    title: 'Финал',
    icon: championshipFinal
  },
  3: {
    title: 'III этап',
    icon: championshipTrophy
  },
  2: {
    title: 'II этап',
    icon: championshipTrophy
  },
  1: {
    title: 'Набор',
    icon: championshipStar
  }
}
